import { Kind } from "@/services/backend/samples/types/kind";
import { EntityId } from "@/shared/types/entity-id";
import { Result } from "@/services/backend/htz/inspection/components/inspection-result";
import { Assessment } from "./assessment";

export type MicrobialAssessment = Assessment & {
  kind: Kind;
  sampleId: EntityId;
  conductedAt: string;
  result: Result;
};

export function newMicrobial(
  id: string,
  ahuId: string,
  componentId: string,
  kind: Kind,
  sampleId: EntityId,
): MicrobialAssessment {
  return {
    id,
    ahuId,
    componentId,
    kind,
    sampleId,
    conductedAt: new Date().toISOString(),
    result: Result.ZERO,
  };
}
